module.exports = __webpack_public_path__ + "static/media/fashup.786c6760.png";